import React from 'react';
import { Outlet } from 'react-router';

import { DevOnlyRoute } from '@/backoffice/app/dev-only-route/dev-only-route';
import { apiLatencyRoutes } from '@/backoffice/app/routes/sre-hub/api-latency/routes';
import { consoleLatencyRoutes } from '@/backoffice/app/routes/sre-hub/console-latency/routes';
import { TCustomRouteObject } from '@/shared/types/router.types';

// DevOnlyRoute gates on its `children` prop, so nested routes need an
// Outlet inside it rather than passing it as the route Component directly.
const SreHubGuard: React.FC = () => (
  <DevOnlyRoute>
    <Outlet />
  </DevOnlyRoute>
);

// No `permission` gate -- gated instead by the `custom:isDeveloper` Cognito
// attribute via DevOnlyRoute, the same gate the back-office queries enforce.
export const sreHubRoutes: TCustomRouteObject = {
  path: 'sre-hub',
  Component: SreHubGuard,
  handle: {
    crumb: {
      label: 'sre_hub',
      localized: true,
    },
  },
  children: [
    {
      index: true,
      lazy: async () => {
        const { SreHubRoute } = await import('./sre-hub');
        return { Component: SreHubRoute };
      },
    },
    consoleLatencyRoutes,
    apiLatencyRoutes,
  ],
};
